
<script lang="ts" setup>
import { ref } from "vue";
import VuePdfEmbed from 'vue-pdf-embed';
import { useContextStore } from "@/store";

defineExpose({ VuePdfEmbed });

const annotationIconsPath = '/node_modules/pdfjs-dist/web/images/';
const props = defineProps<{src: any}>();
const pdfEmbed = ref();

function handleLoaded(e) {
  // Loaded
}
</script>
<template>
  <div class="overflow-auto">
    <vue-pdf-embed
      v-if="!useContextStore().isPlatformBrowser"
      :ref="pdfEmbed"
      :source="src"
      @loaded="handleLoaded"
      :image-resources-path="annotationIconsPath"
    />
    <embed v-else :src="src" zoom="80%" width="100%" class="h-full" />
  </div>
</template>